import HttpMethod from '../../services/httpMethods'
import { ApiResponse } from '../../services/types';
import { makeRequest } from '../../services/restcall';


export async function putUpdatePasswordUserAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/update/password',value)
}
export async function getValidateTokenAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/validate/token?token='+value,{})
}

export async function getCIE10ByFilterAPI(filter:string, value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/cie10?filter='+ filter +'&value='+value, {})
}

export async function getStatusOrganizationAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization-status?tenant='+process.env.REACT_APP_CODE_TENANT,{})
}
export async function getSytemByTokenAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/main/module/user/token',value)
}

export async function getPathologicalHistoryAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/pathological-history',value)
}
export async function getUserInfoByTokenAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/userinformationtoken',value)
}

export async function getUserOdontologicoAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/odontologos',{})
}
export async function getUserAssociatedAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/associated',{})
}

export async function updatepasswordAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/updatepassword',value)
}

export async function getRecoverPasswordAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/recover/passworddni?dni='+encodeURIComponent(value),{})
}

export async function getActiveSpecialityAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/speciality',{})
}

export async function postSpecialityAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/speciality', value)
}

export async function putSpecialityAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/speciality', value)
}

export async function getMedicalRecordSectionsAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/medicalrecordsections', {})
}

export async function postMedicalRecordSectionAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/medicalrecordsections', value)
}

export async function putMedicalRecordSectionAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/medicalrecordsections', value)
}

export async function putSpecialityDefaultSectionsAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/speciality/defaultsections', value)
}

export async function getActiveGroupAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/group?type='+value,{})
}

export async function getUserInformationAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/information',{})
}

export async function getProfileAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/profile', {})
}

export async function getIdentityOrganizationFiscalSourceAPI(organizationId: string): Promise<ApiResponse> {
    return await makeRequest(
        HttpMethod.GET,
        `/api/identity/organization/${encodeURIComponent(organizationId)}/fiscal-source`,
        {}
    );
}

export async function getSalesDocumentFiscalProfileAPI(organizationId: string): Promise<ApiResponse> {
    return await makeRequest(
        HttpMethod.GET,
        `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/fiscal-profile`,
        {}
    );
}

export async function getSalesDocumentRuntimeEnvironmentAPI(): Promise<ApiResponse> {
    return await makeRequest(
        HttpMethod.GET,
        '/api/SalesDocument/runtime-environment',
        {}
    );
}

export async function postSalesDocumentFiscalProfileAPI(organizationId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(
        HttpMethod.POST,
        `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/fiscal-profile`,
        value
    );
}

export async function putSalesDocumentFiscalProfileAPI(organizationId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(
        HttpMethod.PUT,
        `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/fiscal-profile`,
        value
    );
}

export async function getSalesDocumentFiscalConfigurationAPI(organizationId: string): Promise<ApiResponse> {
    return await makeRequest(
        HttpMethod.GET,
        `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/fiscal-configuration`,
        {}
    );
}

export async function getOrganizationTaxConfigurationAPI(organizationId: string, date?: string): Promise<ApiResponse> {
    const query = date ? `?date=${encodeURIComponent(date)}` : '';
    return await makeRequest(HttpMethod.GET, `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/tax-configuration${query}`, {});
}

export async function postOrganizationTaxScheduleAPI(organizationId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/tax-schedules`, value);
}

export async function putOrganizationTaxScheduleAPI(organizationId: string, id: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/tax-schedules/${encodeURIComponent(id)}`, value);
}
export async function getElectronicConfigurationAPI(organizationId: string): Promise<ApiResponse> { return await makeRequest(HttpMethod.GET, `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/electronic-configuration`, {}); }
export async function postSigningCertificateAPI(organizationId: string, value: FormData): Promise<ApiResponse> { return await makeRequest(HttpMethod.POST, `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/signing-certificates`, value); }
export async function putSigningConfigurationAPI(organizationId: string, id: string, value: Object): Promise<ApiResponse> { return await makeRequest(HttpMethod.PUT, `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/signing-configurations/${encodeURIComponent(id)}`, value); }
export async function postElectronicSchemaAssignmentAPI(organizationId: string, value: Object): Promise<ApiResponse> { return await makeRequest(HttpMethod.POST, `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/electronic-schema-assignments`, value); }
export async function putElectronicSchemaAssignmentAPI(organizationId: string, id: string, value: Object): Promise<ApiResponse> { return await makeRequest(HttpMethod.PUT, `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/electronic-schema-assignments/${encodeURIComponent(id)}`, value); }

export async function getSalesDocumentBillingDocumentTypesAPI(): Promise<ApiResponse> {
    return await makeRequest(
        HttpMethod.GET,
        '/api/SalesDocument/billing-document-types',
        {}
    );
}

export async function getSalesDocumentOrganizationBillingDocumentTypesAPI(organizationId: string): Promise<ApiResponse> {
    return await makeRequest(
        HttpMethod.GET,
        `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/billing-document-types`,
        {}
    );
}

export async function postSalesDocumentOrganizationBillingDocumentTypeAPI(organizationId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(
        HttpMethod.POST,
        `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/billing-document-types`,
        value
    );
}

export async function putSalesDocumentOrganizationBillingDocumentTypeAPI(
    organizationId: string,
    organizationBillingDocumentTypeId: string,
    value: Object
): Promise<ApiResponse> {
    return await makeRequest(
        HttpMethod.PUT,
        `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/billing-document-types/${encodeURIComponent(organizationBillingDocumentTypeId)}`,
        value
    );
}

export async function getSalesDocumentPaymentMethodCatalogueAPI(): Promise<ApiResponse> {
    return await makeRequest(
        HttpMethod.GET,
        '/api/SalesDocument/payment-method-catalogue',
        {}
    );
}

export async function getGlobalBillingDocumentTypesAPI(): Promise<ApiResponse> { return await makeRequest(HttpMethod.GET, '/api/SalesDocument/global/billing-document-types', {}); }
export async function postGlobalBillingDocumentTypeAPI(value: Object): Promise<ApiResponse> { return await makeRequest(HttpMethod.POST, '/api/SalesDocument/global/billing-document-types', value); }
export async function putGlobalBillingDocumentTypeAPI(id: string, value: Object): Promise<ApiResponse> { return await makeRequest(HttpMethod.PUT, `/api/SalesDocument/global/billing-document-types/${encodeURIComponent(id)}`, value); }
export async function getGlobalPaymentMethodsAPI(): Promise<ApiResponse> { return await makeRequest(HttpMethod.GET, '/api/SalesDocument/global/payment-method-catalogue', {}); }
export async function postGlobalPaymentMethodAPI(value: Object): Promise<ApiResponse> { return await makeRequest(HttpMethod.POST, '/api/SalesDocument/global/payment-method-catalogue', value); }
export async function putGlobalPaymentMethodAPI(id: string, value: Object): Promise<ApiResponse> { return await makeRequest(HttpMethod.PUT, `/api/SalesDocument/global/payment-method-catalogue/${encodeURIComponent(id)}`, value); }
export async function getGlobalRefactoringReasonsAPI(): Promise<ApiResponse> { return await makeRequest(HttpMethod.GET, '/api/SalesDocument/global/refactoring-reasons', {}); }
export async function postGlobalRefactoringReasonAPI(value: Object): Promise<ApiResponse> { return await makeRequest(HttpMethod.POST, '/api/SalesDocument/global/refactoring-reasons', value); }
export async function putGlobalRefactoringReasonAPI(id: string, value: Object): Promise<ApiResponse> { return await makeRequest(HttpMethod.PUT, `/api/SalesDocument/global/refactoring-reasons/${encodeURIComponent(id)}`, value); }
export async function getGlobalRefactoringPoliciesAPI(): Promise<ApiResponse> { return await makeRequest(HttpMethod.GET, '/api/SalesDocument/global/refactoring-policies', {}); }
export async function postGlobalRefactoringPolicyAPI(value: Object): Promise<ApiResponse> { return await makeRequest(HttpMethod.POST, '/api/SalesDocument/global/refactoring-policies', value); }
export async function putGlobalRefactoringPolicyAPI(id: string, value: Object): Promise<ApiResponse> { return await makeRequest(HttpMethod.PUT, `/api/SalesDocument/global/refactoring-policies/${encodeURIComponent(id)}`, value); }
export async function getGlobalTaxDefinitionsAPI(): Promise<ApiResponse> { return await makeRequest(HttpMethod.GET, '/api/SalesDocument/global/tax-rate-definitions', {}); }
export async function postGlobalTaxDefinitionAPI(value: Object): Promise<ApiResponse> { return await makeRequest(HttpMethod.POST, '/api/SalesDocument/global/tax-rate-definitions', value); }
export async function putGlobalTaxDefinitionAPI(id: string, value: Object): Promise<ApiResponse> { return await makeRequest(HttpMethod.PUT, `/api/SalesDocument/global/tax-rate-definitions/${encodeURIComponent(id)}`, value); }
export async function getGlobalTaxSchedulesAPI(): Promise<ApiResponse> { return await makeRequest(HttpMethod.GET, '/api/SalesDocument/global/tax-global-schedules', {}); }
export async function postGlobalTaxScheduleAPI(value: Object): Promise<ApiResponse> { return await makeRequest(HttpMethod.POST, '/api/SalesDocument/global/tax-global-schedules', value); }
export async function putGlobalTaxScheduleAPI(id: string, value: Object): Promise<ApiResponse> { return await makeRequest(HttpMethod.PUT, `/api/SalesDocument/global/tax-global-schedules/${encodeURIComponent(id)}`, value); }
export async function getGlobalSchemaVersionsAPI(): Promise<ApiResponse> { return await makeRequest(HttpMethod.GET, '/api/SalesDocument/global/electronic-schema-versions', {}); }
export async function postGlobalSchemaVersionAPI(value: Object): Promise<ApiResponse> { return await makeRequest(HttpMethod.POST, '/api/SalesDocument/global/electronic-schema-versions', value); }
export async function putGlobalSchemaVersionAPI(id: string, value: Object): Promise<ApiResponse> { return await makeRequest(HttpMethod.PUT, `/api/SalesDocument/global/electronic-schema-versions/${encodeURIComponent(id)}`, value); }

export async function getSalesDocumentOrganizationPaymentMethodsAPI(organizationId: string): Promise<ApiResponse> {
    return await makeRequest(
        HttpMethod.GET,
        `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/payment-methods`,
        {}
    );
}

export async function postSalesDocumentOrganizationPaymentMethodAPI(organizationId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(
        HttpMethod.POST,
        `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/payment-methods`,
        value
    );
}

export async function putSalesDocumentOrganizationPaymentMethodAPI(
    organizationId: string,
    organizationPaymentMethodId: string,
    value: Object
): Promise<ApiResponse> {
    return await makeRequest(
        HttpMethod.PUT,
        `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/payment-methods/${encodeURIComponent(organizationPaymentMethodId)}`,
        value
    );
}

export async function postSalesDocumentFiscalEstablishmentAPI(organizationId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(
        HttpMethod.POST,
        `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/fiscal-establishments`,
        value
    );
}

export async function putSalesDocumentFiscalEstablishmentAPI(organizationId: string, establishmentId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(
        HttpMethod.PUT,
        `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/fiscal-establishments/${encodeURIComponent(establishmentId)}`,
        value
    );
}

export async function postSalesDocumentFiscalPointAPI(organizationId: string, establishmentId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(
        HttpMethod.POST,
        `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/fiscal-establishments/${encodeURIComponent(establishmentId)}/points-of-emission`,
        value
    );
}

export async function putSalesDocumentFiscalPointAPI(organizationId: string, pointId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(
        HttpMethod.PUT,
        `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/fiscal-points-of-emission/${encodeURIComponent(pointId)}`,
        value
    );
}

export async function postSalesDocumentFiscalSequenceAPI(organizationId: string, pointId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(
        HttpMethod.POST,
        `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/fiscal-points-of-emission/${encodeURIComponent(pointId)}/sequences`,
        value
    );
}

export async function putSalesDocumentFiscalSequenceAPI(organizationId: string, sequenceId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(
        HttpMethod.PUT,
        `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/fiscal-sequences/${encodeURIComponent(sequenceId)}`,
        value
    );
}

/** Crea una factura directa sin turno ni caja abierta. */
export async function postSalesDocumentDirectAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(
        HttpMethod.POST,
        '/api/SalesDocument/documents/direct',
        value
    );
}

/** Registra el pago de una factura directa; turnId permanece nulo. */
export async function postSalesDocumentDirectPaymentAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(
        HttpMethod.POST,
        '/api/SalesDocument/payments/direct',
        value
    );
}

export async function getSalesDocumentByIdAPI(id: string): Promise<ApiResponse> {
    return await makeRequest(
        HttpMethod.GET,
        `/api/SalesDocument/documents/${encodeURIComponent(id)}`,
        {}
    );
}

export async function getSalesDocumentListAPI(
    organizationId: string,
    params: {
        search?: string;
        status?: string;
        billingMode?: string;
        fromDate?: string;
        toDate?: string;
        page?: number;
        pageSize?: number;
    } = {}
): Promise<ApiResponse> {
    const query = new URLSearchParams();
    if (params.search) query.set('search', params.search);
    if (params.status) query.set('status', params.status);
    if (params.billingMode) query.set('billingMode', params.billingMode);
    if (params.fromDate) query.set('fromDate', params.fromDate);
    if (params.toDate) query.set('toDate', params.toDate);
    if (params.page) query.set('page', String(params.page));
    if (params.pageSize) query.set('pageSize', String(params.pageSize));

    const suffix = query.toString() ? `?${query.toString()}` : '';
    return await makeRequest(
        HttpMethod.GET,
        `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/documents${suffix}`,
        {}
    );
}

export async function getSalesDocumentClientByIdentificationAPI(
    organizationId: string,
    identificationNumber: string
): Promise<ApiResponse> {
    return await makeRequest(
        HttpMethod.GET,
        `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/clients/by-identification/${encodeURIComponent(identificationNumber.trim())}`,
        {}
    );
}

export async function getSytemByUserIdAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/main/module/user?id='+value,{})
}

export async function getOrganizationRefactoringReasonsAPI(organizationId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET,
        `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/refactoring-reasons`, {});
}

export async function postOrganizationRefactoringReasonAPI(organizationId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST,
        `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/refactoring-reasons`, value);
}

export async function putOrganizationRefactoringReasonAPI(organizationId: string, id: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT,
        `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/refactoring-reasons/${encodeURIComponent(id)}`, value);
}

export async function getDocumentRefactoringPreviewAPI(organizationId: string, documentId: string, organizationReasonId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET,
        `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/documents/${encodeURIComponent(documentId)}/refactoring-preview?organizationReasonId=${encodeURIComponent(organizationReasonId)}`, {});
}

export async function postDocumentRefactoringAPI(organizationId: string, documentId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST,
        `/api/SalesDocument/organization/${encodeURIComponent(organizationId)}/documents/${encodeURIComponent(documentId)}/refactor`, value);
}


export async function getGroupModuleAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/group-module',{})
}

export async function getModulesAPI(value:string,value2:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/modules?mainModuleId='+value+"&rolId="+value2,{})
}

export async function postLoginAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/login',value)
}

export async function getAllModuleTokenWithUserAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/module-token', value)
}

export async function getAllTableUserAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/user',{})
}
export async function updateUserAsyncAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/user',value)
}

export async function updateStatusUserAsyncAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/user/status',value)
}
export async function postRegisterUserAsyncAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/user',value)
}

export async function postOnboardingRegisterAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/register', value)
}

export async function searchOrganizationsAPI(value: string, take: number = 20): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization/search?value=' + encodeURIComponent(value) + '&take=' + take, {})
}

export async function getOrganizationManagementOrganizationsAPI(search?: string): Promise<ApiResponse> {
    const query = search ? '?search=' + encodeURIComponent(search) : '';
    return await makeRequest(HttpMethod.GET, '/api/identity/organization-management/organizations' + query, {})
}

export async function putOrganizationAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/organization', value)
}

export async function getGlobalPhysicalSpaceTypesAPI(status?: string): Promise<ApiResponse> {
    const query = status ? '?status=' + encodeURIComponent(status) : '';
    return await makeRequest(HttpMethod.GET, '/api/identity/global-configurations/physical-space-types' + query, {})
}

export async function postGlobalPhysicalSpaceTypeAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/global-configurations/physical-space-types', value)
}

export async function putGlobalPhysicalSpaceTypeAPI(id: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/global-configurations/physical-space-types/' + encodeURIComponent(id), value)
}

export async function inactivateGlobalPhysicalSpaceTypeAPI(id: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/global-configurations/physical-space-types/' + encodeURIComponent(id) + '/inactivate', {})
}

export async function getGlobalDocumentTypesAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/procedure-document-types', {})
}

export async function getProcedureDocumentTemplateTagsAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/procedure-document-template-tags', {})
}

export async function postGlobalDocumentTypeAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/procedure-document-types', value)
}

export async function putGlobalDocumentTypeAPI(id: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/procedure-document-types/' + encodeURIComponent(id), value)
}

export async function deleteGlobalDocumentTypeAPI(id: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/identity/procedure-document-types/' + encodeURIComponent(id), {})
}

/**
 * Documentos operativos de una organización (pdt.documents).
 * El catálogo de tipos se mantiene globalmente en pdt.type_documents;
 * estas operaciones solo crean/modifican la instancia de la organización.
 */
export async function getOrganizationProcedureDocumentsAPI(organizationId: string, status?: string): Promise<ApiResponse> {
    const query = status ? '?status=' + encodeURIComponent(status) : '';
    return await makeRequest(HttpMethod.GET, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/procedure-documents' + query, {})
}

export async function postOrganizationProcedureDocumentAPI(organizationId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/procedure-documents', value)
}

export async function putOrganizationProcedureDocumentAPI(organizationId: string, documentId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/procedure-documents/' + encodeURIComponent(documentId), value)
}

export async function inactivateOrganizationProcedureDocumentAPI(organizationId: string, documentId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/procedure-documents/' + encodeURIComponent(documentId) + '/inactivate', {})
}

export async function getOrganizationProcedureDocumentFileAPI(organizationId: string, documentId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/procedure-documents/' + encodeURIComponent(documentId) + '/file', {})
}

export async function getOrganizationManagementCentersAPI(organizationId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization-management/organizations/' + encodeURIComponent(organizationId) + '/centers', {})
}

export async function getOrganizationManagementPlanAPI(organizationId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization-management/organizations/' + encodeURIComponent(organizationId) + '/plan', {})
}

export async function getOrganizationManagementContractAPI(organizationId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization-management/organizations/' + encodeURIComponent(organizationId) + '/contract', {})
}

export async function putOrganizationManagementContractAPI(organizationId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/organization-management/organizations/' + encodeURIComponent(organizationId) + '/contract', value)
}

export async function getContractBillingDocumentsAPI(organizationId: string, contractId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, `/api/identity/organization-management/organizations/${encodeURIComponent(organizationId)}/contracts/${encodeURIComponent(contractId)}/billing-documents`, {})
}

export async function postContractBillingDocumentAPI(organizationId: string, contractId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, `/api/identity/organization-management/organizations/${encodeURIComponent(organizationId)}/contracts/${encodeURIComponent(contractId)}/billing-documents`, value)
}

export async function putContractBillingDocumentAPI(organizationId: string, contractId: string, documentId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, `/api/identity/organization-management/organizations/${encodeURIComponent(organizationId)}/contracts/${encodeURIComponent(contractId)}/billing-documents/${encodeURIComponent(documentId)}`, value)
}

export async function deleteContractBillingDocumentAPI(organizationId: string, contractId: string, documentId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, `/api/identity/organization-management/organizations/${encodeURIComponent(organizationId)}/contracts/${encodeURIComponent(contractId)}/billing-documents/${encodeURIComponent(documentId)}`, {})
}

export async function getContractBillingDocumentFileAPI(organizationId: string, contractId: string, documentId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, `/api/identity/organization-management/organizations/${encodeURIComponent(organizationId)}/contracts/${encodeURIComponent(contractId)}/billing-documents/${encodeURIComponent(documentId)}/file`, {})
}

export async function getContractBillingPaymentsAPI(organizationId: string, contractId: string, documentId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, `/api/identity/organization-management/organizations/${encodeURIComponent(organizationId)}/contracts/${encodeURIComponent(contractId)}/billing-documents/${encodeURIComponent(documentId)}/payments`, {})
}

export async function postContractBillingPaymentAPI(organizationId: string, contractId: string, documentId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, `/api/identity/organization-management/organizations/${encodeURIComponent(organizationId)}/contracts/${encodeURIComponent(contractId)}/billing-documents/${encodeURIComponent(documentId)}/payments`, value)
}

export async function putContractBillingDocumentMoraAPI(organizationId: string, contractId: string, documentId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, `/api/identity/organization-management/organizations/${encodeURIComponent(organizationId)}/contracts/${encodeURIComponent(contractId)}/billing-documents/${encodeURIComponent(documentId)}/mora`, value)
}

export async function deleteContractBillingPaymentAPI(organizationId: string, contractId: string, documentId: string, paymentId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, `/api/identity/organization-management/organizations/${encodeURIComponent(organizationId)}/contracts/${encodeURIComponent(contractId)}/billing-documents/${encodeURIComponent(documentId)}/payments/${encodeURIComponent(paymentId)}`, {})
}

export async function getContractBillingPaymentFileAPI(organizationId: string, contractId: string, documentId: string, paymentId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, `/api/identity/organization-management/organizations/${encodeURIComponent(organizationId)}/contracts/${encodeURIComponent(contractId)}/billing-documents/${encodeURIComponent(documentId)}/payments/${encodeURIComponent(paymentId)}/file`, {})
}

export async function getContractDocumentsAPI(organizationId: string, contractId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, `/api/identity/organization-management/organizations/${encodeURIComponent(organizationId)}/contracts/${encodeURIComponent(contractId)}/documents`, {})
}

export async function postContractDocumentAPI(organizationId: string, contractId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, `/api/identity/organization-management/organizations/${encodeURIComponent(organizationId)}/contracts/${encodeURIComponent(contractId)}/documents`, value)
}

export async function deleteContractDocumentAPI(organizationId: string, contractId: string, documentId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, `/api/identity/organization-management/organizations/${encodeURIComponent(organizationId)}/contracts/${encodeURIComponent(contractId)}/documents/${encodeURIComponent(documentId)}`, {})
}

export async function getContractDocumentFileAPI(organizationId: string, contractId: string, documentId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, `/api/identity/organization-management/organizations/${encodeURIComponent(organizationId)}/contracts/${encodeURIComponent(contractId)}/documents/${encodeURIComponent(documentId)}/file`, {})
}

export async function postContractBillingDueEvaluationAPI(organizationId: string, contractId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, `/api/identity/organization-management/organizations/${encodeURIComponent(organizationId)}/contracts/${encodeURIComponent(contractId)}/billing-documents/evaluate`, {})
}

export async function getContractBillingMetricsAPI(organizationId: string, contractId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, `/api/identity/organization-management/organizations/${encodeURIComponent(organizationId)}/contracts/${encodeURIComponent(contractId)}/billing-documents/metrics`, {})
}

export async function putContractBillingSalesDocumentAPI(organizationId: string, contractId: string, documentId: string, salesDocumentId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, `/api/identity/organization-management/organizations/${encodeURIComponent(organizationId)}/contracts/${encodeURIComponent(contractId)}/billing-documents/${encodeURIComponent(documentId)}/sales-document/${encodeURIComponent(salesDocumentId)}`, {})
}

export async function getOrganizationManagementStaffAPI(organizationId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization-management/organizations/' + encodeURIComponent(organizationId) + '/staff', {})
}

export async function getOrganizationManagementStaffRolesAPI(organizationId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization-management/organizations/' + encodeURIComponent(organizationId) + '/staff/roles', {})
}

export interface OrganizationManagementStaffAuditQuery {
    from?: string;
    to?: string;
    actor?: string;
    target?: string;
    action?: string;
    entityType?: string;
    search?: string;
    page?: number;
    pageSize?: number;
}

export async function getOrganizationManagementStaffAuditAPI(
    organizationId: string,
    query: OrganizationManagementStaffAuditQuery = {}
): Promise<ApiResponse> {
    const params = new URLSearchParams();
    Object.entries(query).forEach(([key, value]) => {
        if (value !== undefined && value !== null && String(value).trim() !== '') {
            params.set(key, String(value));
        }
    });
    const suffix = params.toString() ? `?${params.toString()}` : '';
    return await makeRequest(
        HttpMethod.GET,
        '/api/identity/organization-management/organizations/' + encodeURIComponent(organizationId) + '/staff/audit' + suffix,
        {}
    )
}

export async function postOrganizationManagementStaffAPI(organizationId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/organization-management/organizations/' + encodeURIComponent(organizationId) + '/staff', value)
}

export async function putOrganizationManagementStaffAPI(organizationId: string, staffId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/organization-management/organizations/' + encodeURIComponent(organizationId) + '/staff/' + encodeURIComponent(staffId), value)
}

export interface OrganizationMedicalFeeQuery {
    userId?: string;
    organizationProductId?: string;
    scope?: string;
}

export async function getOrganizationMedicalFeesAPI(organizationId: string, query: OrganizationMedicalFeeQuery = {}): Promise<ApiResponse> {
    const params = new URLSearchParams();
    Object.entries(query).forEach(([key, value]) => {
        if (value !== undefined && value !== null && String(value).trim() !== '') params.set(key, String(value));
    });
    const suffix = params.toString() ? '?' + params.toString() : '';
    return await makeRequest(HttpMethod.GET, '/api/identity/organization-management/organizations/' + encodeURIComponent(organizationId) + '/medical-fees' + suffix, {})
}

export async function postOrganizationMedicalFeeAPI(organizationId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/organization-management/organizations/' + encodeURIComponent(organizationId) + '/medical-fees', value)
}

export async function putOrganizationMedicalFeeAPI(organizationId: string, id: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/organization-management/organizations/' + encodeURIComponent(organizationId) + '/medical-fees/' + encodeURIComponent(id), value)
}

export async function deleteOrganizationMedicalFeeAPI(organizationId: string, id: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/identity/organization-management/organizations/' + encodeURIComponent(organizationId) + '/medical-fees/' + encodeURIComponent(id), {})
}


export async function getOrganizationManagementSpecialitiesAPI(organizationId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization-management/organizations/' + encodeURIComponent(organizationId) + '/specialities', {})
}

export async function putOrganizationManagementSpecialityAPI(organizationId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/organization-management/organizations/' + encodeURIComponent(organizationId) + '/specialities', value)
}

export async function postOrganizationManagementCenterAPI(organizationId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/organization-management/organizations/' + encodeURIComponent(organizationId) + '/centers', value)
}

export async function putOrganizationManagementCenterAPI(centerId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/organization-management/centers/' + encodeURIComponent(centerId), value)
}

export async function getOrganizationCenterSpecialitiesAPI(centerId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization-management/centers/' + encodeURIComponent(centerId) + '/specialities', {})
}

export async function putOrganizationCenterSpecialityAPI(centerId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/organization-management/centers/' + encodeURIComponent(centerId) + '/specialities', value)
}

export async function getOrganizationManagementProductsAPI(
    organizationId: string,
    search?: string,
    includeCatalog = false,
    serviceId?: string,
    page?: number,
    pageSize?: number
): Promise<ApiResponse> {
    const queryParams = [
        search ? 'search=' + encodeURIComponent(search) : '',
        includeCatalog ? 'includeCatalog=true' : '',
        serviceId ? 'serviceId=' + encodeURIComponent(serviceId) : '',
        page !== undefined ? 'page=' + encodeURIComponent(String(page)) : '',
        pageSize !== undefined ? 'pageSize=' + encodeURIComponent(String(pageSize)) : ''
    ].filter(Boolean).join('&');
    const query = queryParams ? '?' + queryParams : '';
    return await makeRequest(HttpMethod.GET, '/api/identity/organization-management/organizations/' + encodeURIComponent(organizationId) + '/products' + query, {})
}

/**
 * Catálogo global paginado. Este endpoint se usa únicamente para localizar
 * un producto Blue por servicio; la lista de productos ya registrados en la
 * organización se obtiene con getOrganizationManagementProductsAPI.
 */
export async function getOrganizationCatalogProductsAPI(
    organizationId: string,
    serviceId?: string,
    search?: string,
    page = 1,
    pageSize = 25
): Promise<ApiResponse> {
    const params = new URLSearchParams();
    if (serviceId) params.set('serviceId', serviceId);
    if (search) params.set('search', search);
    params.set('page', String(page));
    params.set('pageSize', String(pageSize));
    return await makeRequest(
        HttpMethod.GET,
        '/api/identity/organization-management/organizations/' + encodeURIComponent(organizationId) + '/products/catalog?' + params.toString(),
        {}
    );
}

export async function postOrganizationManagementProductAPI(organizationId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/organization-management/organizations/' + encodeURIComponent(organizationId) + '/products', value)
}

/** Crea un producto propio en pdt.products asociado al serviceId global. */
export async function postOrganizationLocalProductAPI(organizationId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/organization-management/organizations/' + encodeURIComponent(organizationId) + '/products/local', value)
}

export async function putOrganizationManagementProductAPI(organizationId: string, organizationProductId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/organization-management/organizations/' + encodeURIComponent(organizationId) + '/products/' + encodeURIComponent(organizationProductId), value)
}

export async function getBusinessAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/business', {})
}

export async function getBusinessOrganizationsAPI(organizationId: string, status?: string): Promise<ApiResponse> {
    const query = status ? '?status=' + encodeURIComponent(status) : '';
    return await makeRequest(HttpMethod.GET, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/business-organizations' + query, {})
}

export async function postBusinessOrganizationAPI(organizationId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/business-organizations', value)
}

export async function putBusinessOrganizationAPI(organizationId: string, id: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/business-organizations/' + encodeURIComponent(id), value)
}

export async function inactivateBusinessOrganizationAPI(organizationId: string, id: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/business-organizations/' + encodeURIComponent(id) + '/inactivate', {})
}

export async function getBusinessAgreementsAPI(organizationId: string, businessOrganizationId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/business-organizations/' + encodeURIComponent(businessOrganizationId) + '/agreements', {})
}

export async function postBusinessAgreementAPI(organizationId: string, businessOrganizationId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/business-organizations/' + encodeURIComponent(businessOrganizationId) + '/agreements', value)
}

export async function putBusinessAgreementAPI(organizationId: string, businessOrganizationId: string, id: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/business-organizations/' + encodeURIComponent(businessOrganizationId) + '/agreements/' + encodeURIComponent(id), value)
}

// Cobertura global del convenio. Estas filas no pertenecen a un plan
// específico y se identifican en backend con coveragePlanId = null. Cuando se
// envían filtros/paginación, el backend devuelve { items, total, page, pageSize }.
export async function getGlobalProductsCoverageAPI(
    organizationId: string,
    agreementId: string,
    serviceId?: string,
    search?: string,
    page?: number,
    pageSize?: number
): Promise<ApiResponse> {
    const query = new URLSearchParams();
    if (serviceId) query.set('serviceId', serviceId);
    if (search && search.trim()) query.set('search', search.trim());
    if (page !== undefined) query.set('page', String(page));
    if (pageSize !== undefined) query.set('pageSize', String(pageSize));
    const suffix = query.toString() ? `?${query.toString()}` : '';
    return await makeRequest(
        HttpMethod.GET,
        '/api/identity/organization/' + encodeURIComponent(organizationId) + '/agreements/' + encodeURIComponent(agreementId) + '/products-coverage' + suffix,
        {}
    )
}

export async function postGlobalProductsCoverageAPI(organizationId: string, agreementId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/agreements/' + encodeURIComponent(agreementId) + '/products-coverage', value)
}

export async function putGlobalProductsCoverageAPI(organizationId: string, agreementId: string, id: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/agreements/' + encodeURIComponent(agreementId) + '/products-coverage/' + encodeURIComponent(id), value)
}

export async function getGlobalServicesCoverageAPI(organizationId: string, agreementId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/agreements/' + encodeURIComponent(agreementId) + '/services-coverage', {})
}

export async function postGlobalServiceCoverageAPI(organizationId: string, agreementId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/agreements/' + encodeURIComponent(agreementId) + '/services-coverage', value)
}

export async function putGlobalServiceCoverageAPI(organizationId: string, agreementId: string, id: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/agreements/' + encodeURIComponent(agreementId) + '/services-coverage/' + encodeURIComponent(id), value)
}

export async function getBusinessGroupsAPI(organizationId: string, agreementId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/agreements/' + encodeURIComponent(agreementId) + '/groups', {})
}

export async function postBusinessGroupAPI(organizationId: string, agreementId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/agreements/' + encodeURIComponent(agreementId) + '/groups', value)
}

export async function putBusinessGroupAPI(organizationId: string, agreementId: string, id: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/agreements/' + encodeURIComponent(agreementId) + '/groups/' + encodeURIComponent(id), value)
}

export async function getCoveragePlansAPI(organizationId: string, groupId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/groups/' + encodeURIComponent(groupId) + '/coverage-plans', {})
}

export async function postCoveragePlanAPI(organizationId: string, groupId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/groups/' + encodeURIComponent(groupId) + '/coverage-plans', value)
}

export async function putCoveragePlanAPI(organizationId: string, groupId: string, id: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/groups/' + encodeURIComponent(groupId) + '/coverage-plans/' + encodeURIComponent(id), value)
}

export async function getProductsCoverageAPI(organizationId: string, planId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/coverage-plans/' + encodeURIComponent(planId) + '/products', {})
}

export async function postProductsCoverageAPI(organizationId: string, planId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/coverage-plans/' + encodeURIComponent(planId) + '/products', value)
}

export async function putProductsCoverageAPI(organizationId: string, planId: string, id: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/coverage-plans/' + encodeURIComponent(planId) + '/products/' + encodeURIComponent(id), value)
}

export async function importProductPriceListAPI(organizationId: string, businessOrganizationId: string, planId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/business-organizations/' + encodeURIComponent(businessOrganizationId) + '/coverage-plans/' + encodeURIComponent(planId) + '/products/import', value)
}

export async function getServicesCoverageAPI(organizationId: string, planId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/coverage-plans/' + encodeURIComponent(planId) + '/services', {})
}

export async function postServiceCoverageAPI(organizationId: string, planId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/coverage-plans/' + encodeURIComponent(planId) + '/services', value)
}

export async function putServiceCoverageAPI(organizationId: string, planId: string, id: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/coverage-plans/' + encodeURIComponent(planId) + '/services/' + encodeURIComponent(id), value)
}

export async function getOrganizationClinicalServicesAPI(organizationId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/clinical-services', {})
}

// Configuración de procedimientos (pdt.procedure). El backend filtra y valida
// que el producto pertenezca a un servicio con category = PROCEDIMIENTOS.
export async function getProcedureConfigurationsAPI(organizationId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/procedure-configurations', {})
}

export async function postProcedureConfigurationAPI(organizationId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/procedure-configurations', value)
}

export async function putProcedureConfigurationAPI(organizationId: string, procedureId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/procedure-configurations/' + encodeURIComponent(procedureId), value)
}

export async function validateProcedureConfigurationAPI(organizationId: string, procedureId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/procedure-configurations/' + encodeURIComponent(procedureId) + '/validate', {})
}

export async function getProcedureDocumentAssignmentsAPI(organizationId: string, procedureId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/procedure-configurations/' + encodeURIComponent(procedureId) + '/documents', {})
}

export async function postProcedureDocumentAssignmentAPI(organizationId: string, procedureId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/procedure-configurations/' + encodeURIComponent(procedureId) + '/documents', value)
}

export async function putProcedureDocumentAssignmentAPI(organizationId: string, procedureId: string, assignmentId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/procedure-configurations/' + encodeURIComponent(procedureId) + '/documents/' + encodeURIComponent(assignmentId), value)
}

export async function deleteProcedureDocumentAssignmentAPI(organizationId: string, procedureId: string, assignmentId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/procedure-configurations/' + encodeURIComponent(procedureId) + '/documents/' + encodeURIComponent(assignmentId), {})
}

export async function getOrganizationManagementWarehousesByCenterAPI(centerId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization-management/centers/' + encodeURIComponent(centerId) + '/warehouses', {})
}

export async function postOrganizationManagementWarehouseAPI(centerId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/organization-management/centers/' + encodeURIComponent(centerId) + '/warehouses', value)
}

export async function putOrganizationManagementWarehouseAPI(warehouseId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/organization-management/warehouses/' + encodeURIComponent(warehouseId), value)
}

export async function getOrganizationManagementWarehouseStockAPI(warehouseId: string, lowStockOnly: boolean = false): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization-management/warehouses/' + encodeURIComponent(warehouseId) + '/stock?lowStockOnly=' + lowStockOnly, {})
}

export async function postOrganizationManagementInventoryMovementAPI(warehouseId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/organization-management/warehouses/' + encodeURIComponent(warehouseId) + '/movements', value)
}

export async function getOrganizationManagementInventoryMovementsAPI(warehouseId: string, productId?: string, from?: string, to?: string): Promise<ApiResponse> {
    const params = new URLSearchParams();
    if (productId) params.append('productId', productId);
    if (from) params.append('from', from);
    if (to) params.append('to', to);
    const query = params.toString() ? '?' + params.toString() : '';
    return await makeRequest(HttpMethod.GET, '/api/identity/organization-management/warehouses/' + encodeURIComponent(warehouseId) + '/movements' + query, {})
}

export async function getOrganizationManagementInventoryMovementReasonsAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization-management/inventory-movement-reasons', {})
}

export async function getPlansAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/plan/admin', {})
}

export async function getRolSystemsAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/rolsystem?tenant=' + encodeURIComponent(process.env.REACT_APP_CODE_TENANT || 'TBC'), {})
}

export async function getGlobalAccessConfigurationAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/global-configuration/access', {})
}

export async function getGlobalSystemsAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/global-configuration/systems', {})
}

export async function postGlobalSystemAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/global-configuration/systems', value)
}

export async function putGlobalSystemAPI(id: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/global-configuration/systems/' + encodeURIComponent(id), value)
}

export async function getGlobalRolesAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/global-configuration/roles', {})
}

export async function postGlobalRoleAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/global-configuration/roles', value)
}

export async function putGlobalRoleAPI(id: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/global-configuration/roles/' + encodeURIComponent(id), value)
}

export async function getGlobalModulesAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/global-configuration/modules', {})
}

export async function postGlobalModuleAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/global-configuration/modules', value)
}

export async function putGlobalModuleAPI(id: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/global-configuration/modules/' + encodeURIComponent(id), value)
}

export async function getGlobalRoleSystemsAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/global-configuration/role-systems', {})
}

export async function postGlobalRoleSystemAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/global-configuration/role-systems', value)
}

export async function deleteGlobalRoleSystemAPI(id: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/identity/global-configuration/role-systems/' + encodeURIComponent(id), {})
}

export async function putGlobalRoleSystemModulesAPI(id: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/global-configuration/role-systems/' + encodeURIComponent(id) + '/modules', value)
}

export async function getTbcRolSystemsAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/tbcusers/rolsystems', {})
}

export async function getTbcUsersAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/tbcusers', {})
}

export async function postTbcUserAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/tbcusers', value)
}

export async function putTbcUserAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/tbcusers', value)
}

export async function getCompanyUsersAPI(organizationId?: string): Promise<ApiResponse> {
    const query = organizationId ? '?organizationid=' + encodeURIComponent(organizationId) : '';
    return await makeRequest(HttpMethod.GET, '/api/identity/companyusers' + query, {})
}

export async function getOrganizationMedicsAPI(organizationId?: string | null): Promise<ApiResponse> {
    const query = organizationId ? '?organizationId=' + encodeURIComponent(organizationId) : '';
    return await makeRequest(HttpMethod.GET, '/api/identity/organization/medics' + query, {})
}

export async function getOrganizationMedicByIdAPI(userId: string, organizationId?: string | null): Promise<ApiResponse> {
    const query = '?userId=' + encodeURIComponent(userId) + (organizationId ? '&organizationId=' + encodeURIComponent(organizationId) : '');
    return await makeRequest(HttpMethod.GET, '/api/identity/organization/medics/userid' + query, {})
}

export async function getMedicScheduleByUserAPI(userId: string, organizationId?: string | null): Promise<ApiResponse> {
    const query = '?userId=' + encodeURIComponent(userId) + (organizationId ? '&organizationId=' + encodeURIComponent(organizationId) : '');
    return await makeRequest(HttpMethod.GET, '/api/identity/medicschedule/user' + query, {})
}

export async function getWeekDaysAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/weekdays', {})
}

export async function postMedicScheduleAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/medicschedule', value)
}

export async function putMedicScheduleAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/medicschedule', value)
}

export async function deleteMedicScheduleAPI(id: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/identity/medicschedule?id=' + encodeURIComponent(id), {})
}

export async function getReasonsScheduleExceptionsAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/reasons', {})
}

export async function postScheduleExceptionAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/medicschedule/exception', value)
}

export async function putScheduleExceptionAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/medicschedule/exception', value)
}

export async function deleteScheduleExceptionAPI(id: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/identity/medicschedule/exception?id=' + encodeURIComponent(id), {})
}

export async function getAppointmentsByOrganizationAPI(organizationId?: string | null): Promise<ApiResponse> {
    const query = organizationId ? '?organizationId=' + encodeURIComponent(organizationId) : '';
    return await makeRequest(HttpMethod.GET, '/api/appointment/organization' + query, {})
}

export async function postUserAppointmentAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/appointment/user', value)
}

export async function putAppointmentStatusAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/appointment/status', value)
}

export async function postCompanyUserAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/companyusers', value)
}

export async function putCompanyUserAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/companyusers', value)
}

export async function getServicesAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/services', {})
}

export async function getServicesForManagementAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/services/management', {})
}

export async function postServiceAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/services', value)
}

export async function putServiceAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/services', value)
}

export async function getProductsAPI(serviceId: string | undefined, searchBy: string, search: string): Promise<ApiResponse> {
    const serviceQuery = serviceId
        ? `serviceId=${encodeURIComponent(serviceId)}&`
        : '';
    const query = `${serviceQuery}searchBy=${encodeURIComponent(searchBy)}&search=${encodeURIComponent(search)}`;
    return await makeRequest(HttpMethod.GET, '/api/identity/products?' + query, {})
}

export async function getCatalogProductsAPI(serviceId: string | undefined, searchBy: string, search: string): Promise<ApiResponse> {
    const serviceQuery = serviceId
        ? `serviceId=${encodeURIComponent(serviceId)}&`
        : '';
    const query = `${serviceQuery}searchBy=${encodeURIComponent(searchBy)}&search=${encodeURIComponent(search)}`;
    return await makeRequest(HttpMethod.GET, '/api/identity/products/management?' + query, {})
}

export async function postCatalogProductAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/products/management', value)
}

export async function putCatalogProductAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/products/management', value)
}

export async function postOrganizationProductAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/products/organization', value)
}

export async function putOrganizationProductAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/products/organization', value)
}

export async function getProductPackagesAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/products/clinicalorderprofiles', {})
}

export async function postProductPackageAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/products/clinicalorderprofiles', value)
}

export async function putProductPackageAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/products/clinicalorderprofiles', value)
}

export async function getPlanByCodeAPI(code: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/plan/code?code=' + encodeURIComponent(code), {})
}

export async function postPlanAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/plan', value)
}

export async function putPlanAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/plan', value)
}

export async function postContractAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/contract', value)
}

export async function getContractsExpiringAPI(days?: number | null, organizationId?: string, status?: string): Promise<ApiResponse> {
    const params = new URLSearchParams();
    if (days !== null && days !== undefined) {
        params.append('days', String(days));
    }
    if (organizationId) {
        params.append('organizationid', organizationId);
    }
    if (status && status !== 'TODOS') {
        params.append('status', status);
    }

    const query = params.toString();
    return await makeRequest(HttpMethod.GET, '/api/identity/contracts/expiring' + (query ? '?' + query : ''), {})
}

export async function getContractSalesDocumentsAPI(contractId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/contracts/' + encodeURIComponent(contractId) + '/salesdocuments', {})
}

export async function getOrganizationLegalDocumentsAPI(organizationId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/legaldocuments', {})
}

export async function getLegalDocumentsAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/legaldocuments', {})
}

export async function getAllLegalDocumentsAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/legaldocuments/all', {})
}

export async function postLegalDocumentAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/legaldocuments', value)
}

export async function putLegalDocumentAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/legaldocuments', value)
}

export async function getSalesDocumentsAPI(organizationId?: string, ruc?: string): Promise<ApiResponse> {
    const params = new URLSearchParams();
    if (organizationId) {
        params.append('organizationid', organizationId);
    }
    if (ruc) {
        params.append('ruc', ruc);
    }

    const query = params.toString();
    return await makeRequest(HttpMethod.GET, '/api/identity/salesdocument' + (query ? '?' + query : ''), {})
}

export async function getOrganizationClientDataAPI(organizationId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization/clientdata?organizationid=' + encodeURIComponent(organizationId), {})
}

export async function postContractSalesDocumentAPI(contractId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/contracts/' + encodeURIComponent(contractId) + '/salesdocument', value)
}

export async function prepareContractPayPhonePaymentAPI(contractId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/contracts/' + encodeURIComponent(contractId) + '/payphone/prepare', value)
}

export async function confirmContractPayPhonePaymentAPI(contractId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/contracts/' + encodeURIComponent(contractId) + '/payphone/confirm', value)
}

export async function chargeContractWithCardTokenAPI(contractId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/contracts/' + encodeURIComponent(contractId) + '/payphone/charge-token', value)
}

export async function preparePublicPayPhoneTrialAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/public/payphone/trial/prepare', value)
}

export async function preparePublicPayPhoneTrialFromBridgeAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/public/payphone/trial/prepare-from-token', value)
}

export async function confirmPublicPayPhoneTrialAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/public/payphone/trial/confirm', value)
}

export async function getOrganizationCardTokensAPI(organizationId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/cardtokens', {})
}

export async function getActiveOrganizationCardTokenAPI(organizationId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/cardtoken/active', {})
}

export async function prepareOrganizationCardTokenPayPhoneAPI(organizationId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/cardtoken/payphone/prepare', value)
}

export async function confirmOrganizationCardTokenPayPhoneAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/public/payphone/cardtoken/confirm', value)
}

export async function disableOrganizationCardTokenAPI(cardTokenId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/organization/cardtoken/' + encodeURIComponent(cardTokenId) + '/disable', {})
}

export async function confirmPublicPayPhonePaymentAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/public/payphone/confirm', value)
}

export async function getPendingPaymentRequestInvoicesAPI(organizationId?: string): Promise<ApiResponse> {
    const query = organizationId ? '?organizationid=' + encodeURIComponent(organizationId) : '';
    return await makeRequest(HttpMethod.GET, '/api/identity/paymentrequest/pendinginvoices' + query, {})
}

export async function getOrganizationPaymentRequestsAPI(organizationId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organization/' + encodeURIComponent(organizationId) + '/paymentrequest', {})
}

export async function getPendingCardValidationRequestsAPI(organizationId?: string, search?: string): Promise<ApiResponse> {
    const params = new URLSearchParams();
    if (organizationId) {
        params.append('organizationid', organizationId);
    }
    if (search) {
        params.append('search', search);
    }
    const query = params.toString();
    return await makeRequest(HttpMethod.GET, '/api/identity/paymentrequest/pendingcardvalidation' + (query ? '?' + query : ''), {})
}

export async function regeneratePaymentRequestPayPhoneAPI(paymentRequestId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/paymentrequest/' + encodeURIComponent(paymentRequestId) + '/regenerate-payphone', value)
}

export async function postPaymentRequestSalesDocumentAPI(paymentRequestId: string, value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/paymentrequest/' + encodeURIComponent(paymentRequestId) + '/salesdocument', value)
}

export async function reversePaymentRequestPayPhoneAPI(paymentRequestId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/paymentrequest/' + encodeURIComponent(paymentRequestId) + '/reverse-payphone', {})
}

export async function cancelContractAPI(contractId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/contracts/' + encodeURIComponent(contractId) + '/cancel', {})
}

export async function cancelSalesDocumentAPI(salesDocumentId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/salesdocument/' + encodeURIComponent(salesDocumentId) + '/cancel', {})
}

export async function getOrganizationPaymentMethodAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/organizationpaymentmethod', {})
}

export async function getExpenseCategoriesAPI(onlyActive: boolean = true): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/expensecategory?onlyActive=' + String(onlyActive), {})
}

export async function postExpenseCategoryAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/expensecategory', value)
}

export async function putExpenseCategoryAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/expensecategory', value)
}

export async function getExpensesAPI(paramsValue: { from?: string; to?: string; categoryId?: string; organizationId?: string; status?: string } = {}): Promise<ApiResponse> {
    const params = new URLSearchParams();
    if (paramsValue.from) params.append('from', paramsValue.from);
    if (paramsValue.to) params.append('to', paramsValue.to);
    if (paramsValue.categoryId) params.append('categoryid', paramsValue.categoryId);
    if (paramsValue.organizationId) params.append('organizationid', paramsValue.organizationId);
    if (paramsValue.status) params.append('status', paramsValue.status);
    const query = params.toString();
    return await makeRequest(HttpMethod.GET, '/api/identity/expense' + (query ? '?' + query : ''), {})
}

export async function postExpenseAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/expense', value)
}

export async function putExpenseAPI(value: Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/expense', value)
}

export async function cancelExpenseAPI(id: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.PUT, '/api/identity/expense/' + encodeURIComponent(id) + '/cancel', {})
}

export async function getExpenseDocumentAPI(id: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/expense/' + encodeURIComponent(id) + '/document', {})
}

export async function getFinancialMetricsAPI(paramsValue: { from?: string; to?: string; groupBy?: string; organizationId?: string } = {}): Promise<ApiResponse> {
    const params = new URLSearchParams();
    if (paramsValue.from) params.append('from', paramsValue.from);
    if (paramsValue.to) params.append('to', paramsValue.to);
    if (paramsValue.groupBy) params.append('groupBy', paramsValue.groupBy);
    if (paramsValue.organizationId) params.append('organizationid', paramsValue.organizationId);
    const query = params.toString();
    return await makeRequest(HttpMethod.GET, '/api/identity/financialmetrics' + (query ? '?' + query : ''), {})
}

export async function getExpenseOptionsAPI(organizationId?: string): Promise<ApiResponse> {
    const query = organizationId ? '?organizationid=' + encodeURIComponent(organizationId) : '';
    return await makeRequest(HttpMethod.GET, '/api/identity/expenseoptions' + query, {})
}

export async function getClientDataAPI(ruc: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity/clientdata?ruc=' + encodeURIComponent(ruc), {})
}
